import { Button, ButtonProps, useColorModeValue } from "@chakra-ui/react";
import React, { forwardRef } from "react";

interface Props extends ButtonProps {
  active?: boolean;
  onClick: () => void;
}

export const ButtonFilterStyle = forwardRef(function ButtonElement(
  { onClick, active = false, children, ...rest }: Props,
  ref: React.Ref<HTMLButtonElement>
) {
  const borderActiveColor = useColorModeValue("main.400", "main.600");
  const borderColor = useColorModeValue("gray.300", "gray.600");

  const hoverActiveColor = useColorModeValue("main.100", "main.800");
  const hoverColor = useColorModeValue("rgba(0,0,0, 0.04)", "rgba(0,0,0, 0.3)");

  const color = useColorModeValue("main.600", "main.200");
  const bgColor = useColorModeValue("main.50", "main.900");

  return (
    <Button
      ref={ref}
      variant="unstyled"
      borderWidth="thin"
      borderRadius="md"
      borderColor={active ? borderActiveColor : borderColor}
      borderStyle="solid"
      _hover={{ bgColor: active ? hoverActiveColor : hoverColor }}
      _focus={{ boxShadow: "none" }}
      color={active ? color : ""}
      bgColor={active ? bgColor : ""}
      fontWeight="normal"
      size="sm"
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
});
